import React from 'react';
import {Route, Redirect} from 'react-router-dom';
import { CheckValue } from './CommonFunction';
import { messageService } from './subscriberService';

const protectedRoute = ({component: Component, ...rest}) => {
    messageService.count = [];
    EventListners(false);
    // const insideClass = localStorage.getItem('inside-class');
    // const insidesClass = localStorage.getItem('insides-class');
    // const currentActivityId = localStorage.getItem('currentActivityId');
    // const currentActivityIds = localStorage.getItem('currentActivityIds');
    return (
        <Route
        { ...rest }
        render = { props => {
                // console.info('props.location',props.location);        
                if( localStorage.getItem('accessToken') ) {
                    if(CheckSignupStep()) {
                        return RedirectLocation('/SignUpSteps',props.location);
                    } else if(props.location.pathname.includes("autocue")){
                        return <Component { ...props } />;  
                    // } else if(CheckValue(currentActivityId)) {
                    //     const isInside = props.location.pathname.includes(staticVar.liveWorkoutPathName);
                    //     if(!checkRole('gym') && !isInside && !CheckValue(insideClass) ){
                    //             return RedirectLocation(staticVar.liveWorkoutPathName,props.location);
                    //         } else if(isInside && CheckValue(insideClass) && insideClass === currentActivityId){
                    //             return RedirectLocation('/ongoingActivity',props.location);
                    //         } 
                    // } else if(CheckValue(currentActivityIds)) {
                    //     const isInside = props.location.pathname.includes("/HangoutRoom");
                    //     if(!checkRole('gym') && !isInside && !CheckValue(insidesClass) ){
                    //             return RedirectLocation('/HangoutRoom',props.location);
                    //         } else if(isInside && CheckValue(insidesClass) && insidesClass === currentActivityIds){
                    //             return RedirectLocation('/ongoingActivity',props.location);
                    //         } 
                    // } else if(props.location.pathname.includes("HangoutRoom") && CheckValue(insidesClass)){
                    //     return RedirectLocation('/ongoingActivity',props.location);
                    }
                    return <Component { ...props } />;   
                } else {
                    return RedirectLocation('/Login',props.location);
                }      
            }}    
        />
    );
}

const SignUpRoute = ({component: Component, ...rest}) => {
    EventListners(false);
    return (
        <Route
            { ...rest }
            render = { props => {
                if( localStorage.getItem('accessToken') ) {
                    if(CheckSignupStep()) {
                        return <Component { ...props } />;   
                    } else {
                        return RedirectLocation('/',props.location);
                    }
                } else {
                    return RedirectLocation('/Login',props.location);
                }      
            }}    
        />
    );
}

const LoginRoute = ({component: Component, ...rest}) => {
    EventListners(true);
    return (
        <Route
            { ...rest }
            render = { props => {
                if( localStorage.getItem('accessToken') ) {
                    if(CheckSignupStep()) {
                        return RedirectLocation('/SignUpSteps',props.location);
                    } else {
                        return RedirectLocation('/',props.location);
                    }
                } else {
                    return <Component { ...props } />;         
                }      
            }}    
        />
    );
}

export default protectedRoute;

export { SignUpRoute, LoginRoute }

const CheckSignupStep = () => { return localStorage.getItem("formStep") && (!CheckValue(localStorage.getItem("formStep")) || parseInt(localStorage.getItem("formStep"),10) < 10)};
const EventListners = (status) => { 
    window.addEventListener('storage', (data) => {
        if(data.key === 'accessToken' && (status?data.newValue !== null:data.newValue === null)) {
            window.location.reload();
        }
    });
};

const RedirectLocation = (path,location) => {  
    return <Redirect to = {{
        pathname: path,
        state: { from : location }    
    } }
/>};